import { ObjectClass } from "./object-class";
import { OrderByMode } from "./order-by-mode";
import { PlatformLanguageCode } from "./platform-language-code";
import { TitleManagementMode } from "./title-management-mode";

export class GenerateCompilationRequest {
  // Main props
  titleIdAndContentsIds: Record<number, number[]> | null = {};
  tags: string[] | null = null;
  targetDuration: number | null = 0;
  audioLanguageCode: PlatformLanguageCode | null = null;
  // Settings
  skipMarkersToUseIds: number[] | null = null;
  keepFirstIntroOfTitles: boolean | null = null;
  keepLastCreditsOfTitles: boolean | null = null;
  titleManagementMode: TitleManagementMode | null = null;
  orderByMode: OrderByMode | null = null;
  shuffleAssetLists: boolean | null = null;
  objectClasses: ObjectClass[] | null = null;
  distinctTracksByTitle: boolean | null = null;
  harmonizeTitleDurations: boolean | null = null;
  takeRandomAssetsIfNotEnoughTagged: boolean | null = null;
  shuffleTitleList: boolean | null = null;
  previousCompilationLimit: number | null = null;

  constructor(init?: Partial<GenerateCompilationRequest>) {
    Object.assign(this, init);
  }
}
